<template>
  <base-page-layout ref="base-page" :title="alteracaoTitle" :hide-breadcrumbs="$getFirstValue()" class="alteracao-banners">
    <v-container class="pa-0" fluid>
      <v-row>
        <v-col>
          <title-description
            :title.sync="commercial.title"
            :description.sync="commercial.description"
            :title-error="$v.commercial.title.$error"
            :title-error-message="errorTitle"
            :description-error="$v.commercial.description.$error"
            :description-error-message="errorDescription"
            :status="commercial.status"
            :disable="isActive"
            :disable-title="isNewAndFranchise"
            :disable-description="isNewAndFranchise"
          ></title-description>
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col>
          <units-configuration :error="$v.commercial.units.$error" :selected-units.sync="commercial.units" :disabled="isNewAndFranchise" />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row align="stretch">
            <v-col cols="7" class="py-0">
              <v-card class="my-0 pa-4" height="569" style="overflow: hidden">
                <p class="title mb-1">Visualização do banner</p>
                <v-row align="center" justify="center" class="phone-row">
                  <div class="configurar-banner">
                    <v-flex xs12 md12>
                      <div class="outer-frame-push">
                        <v-layout justify-center>
                          <v-flex xs4>
                            <v-layout>
                              <v-spacer />
                              <div class="camera-slot" />
                            </v-layout>
                          </v-flex>
                          <v-flex xs4 class="ear-speaker-slot" />
                          <v-flex xs4 />
                        </v-layout>
                        <div class="inner-frame-mobile">
                          <div class="navbar">
                            <span class="navbar-padding">
                              <mf-icon>notifications_none</mf-icon>
                            </span>
                          </div>
                          <div class="box-offers-placeholder"></div>
                          <div :class="boxOffersPlaceholderClasses">
                            <img v-if="hasBanner" :src="commercial.image_url" class="responsive-image" />
                          </div>
                          <div class="box-buttons-group">
                            <div class="box-button-placeholder first-button"></div>
                            <div class="box-button-placeholder second-button"></div>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </div>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="5" class="py-0">
              <v-card class="mb-5" height="196">
                <v-col class="pa-4 px-4">
                  <p class="title mb-1">Escolha uma imagem</p>
                  <mf-image-cropper
                    :mb-size-limit="10"
                    :disabled="isActive || isNewAndFranchise"
                    :upload-image="modifyImg"
                    :error-message="$v.commercial.image_url.$error ? 'Você deve selecionar uma imagem para o banner' : ''"
                    :url="commercial.image_url"
                    :width="bannerSize.width"
                    :height="bannerSize.height"
                    :ratio="ratioForExpandedBanner"
                    show-hint
                    @remove-image="deleteFile"
                    @snackbar="showSnackbar"
                  />
                </v-col>
              </v-card>
              <v-card class="my-5" height="166">
                <v-col class="pa-4 px-4">
                  <p class="title mb-0 d-flex align-center">
                    Data de início e fim
                    <v-tooltip bottom max-width="192px">
                      <template v-slot:activator="{ on }">
                        <span class="d-flex align-centre" v-on="on">
                          <mf-icon class="ml-1" small color="cinza-0">info</mf-icon>
                        </span>
                      </template>
                      <span>Seu banner entra no início do dia escolhido às 00:00 e sai no fim do dia selecionado às 23:59.</span>
                    </v-tooltip>
                  </p>
                  <v-row>
                    <v-col>
                      <mf-date-range-picker
                        label="Início - Fim"
                        :initial-date.sync="commercial.initial_date"
                        :final-date.sync="commercial.final_date"
                        :min="minDate"
                        :error-messages="errorSendDate || errorFinalDate"
                        :edit-only-end-date="this.commercial.status === 'ACTIVE'"
                        :disabled="isFinished || this.disableDatePicker"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
              <v-card height="166">
                <v-col class="pa-4 px-4 pb-5">
                  <p class="title mb-1 d-flex align-center">
                    Prioridade
                    <v-tooltip bottom max-width="192px">
                      <template v-slot:activator="{ on }">
                        <span class="d-flex align-center" v-on="on">
                          <mf-icon class="ml-1" small color="cinza-0">info</mf-icon>
                        </span>
                      </template>
                      <span
                        >A prioridade define qual banner deve ser exibido primeiro. Por exemplo, banners de prioridade alta serão exibidos na primeira
                        posição.</span
                      >
                    </v-tooltip>
                  </p>
                  <v-radio-group v-model="commercial.priority" row dense hide-details class="mt-0" :disabled="isActive || isNewAndFranchise">
                    <v-radio label="Alta" color="primary" :value="commercial.priority <= 3 ? 3 : 6" />
                    <v-radio label="Média" color="primary" :value="commercial.priority <= 3 ? 2 : 5" />
                    <v-radio label="Baixa" color="primary" :value="commercial.priority <= 3 ? 1 : 4" />
                  </v-radio-group>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="my-3">
        <v-col>
          <v-card class="pa-4">
            <p class="title mb-1">Redirecionamento</p>
            <mf-tabs-button v-model="linkRedirect" :disabled="isActive || isNewAndFranchise" :buttons="toggleButtons" />
            <template v-if="linkRedirect === 1">
              <p class="hint-text external mt-2">
                Nessa modalidade o usuário é redirecionado para uma página web externa. Só poderemos levar seus consumidores para endereços seguros, por isso o
                único tipo de link permitido é o que começa com <b>https://</b>. Certifique-se de inserir um link seguro aqui:
              </p>
              <v-col class="pa-0" cols="6">
                <v-text-field
                  v-model="external"
                  placeholder="https://"
                  label="Link"
                  :error="externalError"
                  :error-messages="(externalError && 'Você precisa incluir um link válido.') || ''"
                  outlined
                  :disabled="isActive || isNewAndFranchise"
                  @blur="validateUrlPrefix"
                />
              </v-col>
            </template>
            <template v-if="linkRedirect === 2">
              <p class="hint-text mt-2 mb-0">Selecione a tela do aplicativo para onde o banner deve redirecionar.</p>
              <v-radio-group
                v-model="internal"
                dense
                hide-details
                :disabled="isActive || isNewAndFranchise"
                class="mt-0"
                :error="internalError"
                @change="validateUrlInternal"
              >
                <p v-if="internalError" class="error-text my-2">Você precisa selecionar uma página interna.</p>
                <v-radio-group v-model="internal" dense hide-details class="mt-0">
                  <v-row>
                    <v-col v-for="(item, index) in links" :key="index" cols="3">
                      <mf-tooltip top max-width="250px" variant="secondary" :disabled="item.link !== 'InternalEcommerce'">
                        <template #activator="{ on }">
                          <v-radio v-if="item" :label="item.title" color="primary" :value="item.link" v-on="on" />
                        </template>
                        <span>O cliente será levado à página inicial do E-commerce</span>
                      </mf-tooltip>
                    </v-col>
                  </v-row>
                </v-radio-group>

                <div v-if="internal === 'FlyersScreen'">
                  <div v-if="!disableSelectFlyer">
                    <p class="hint-text mt-2 mb-6" :class="{ 'is-disabled': disableSelectFlyer }">
                      Caso queira redirecionar o consumidor para um encarte específico, selecione abaixo:
                    </p>
                    <v-select
                      v-model="selectedFlyer"
                      outlined
                      :items="flyersOptions"
                      label="Encarte"
                      item-text="title"
                      return-object
                      style="width: 300px"
                      @change="onFlyerSelect"
                    />
                  </div>
                </div>
              </v-radio-group>
            </template>
            <template v-if="[3, 4].includes(linkRedirect)">
              <p class="hint-text mt-4 mb-4" :class="{ 'is-disabled': disableToggleOffer }">
                Selecione a oferta para onde o banner deve redirecionar. Ao selecionar uma oferta, a data de validade da campanha de banner será fixada na mesma
                data de validade da oferta.
              </p>
              <div>
                <paginated-data-table
                  :headers="headers"
                  :query="query"
                  :custom-items-per-page="5"
                  :query-variables="queryVariables"
                  :graphql-uri="$microservicesUrls['sales']"
                  :query-name="queryName"
                  :disable="disableToggleOffer"
                >
                  <template #item="{ item }">
                    <tr height="46">
                      <td>
                        <v-radio-group :key="item._id" v-model="markedCampaign" column>
                          <v-radio label="" color="primary" :value="item._id" @click="toggleOfferSelected(item)" />
                        </v-radio-group>
                      </td>
                      <td>
                        <div class="status-container">
                          <mf-icon fill small :color="getStatusLabel(item.status).color"> fiber_manual_record </mf-icon>
                          {{ getStatusLabel(item.status).text }}
                        </div>
                      </td>
                      <td class="nowrap-row" style="max-width: 300px">
                        <v-tooltip v-model="showTooltipTitle[item._id]" max-width="250" top content-class="truncated-tooltip">
                          <template #activator="{ on }">
                            <span v-on="on">
                              {{ putEllipsis(item.name, 60) }}
                            </span>
                          </template>
                          <span>{{ item.name }}</span>
                        </v-tooltip>
                      </td>
                      <td class="nowrap-row" style="max-width: 300px">
                        <v-tooltip v-model="showTooltipDescription[item._id]" top max-width="250" content-class="truncated-tooltip">
                          <template #activator="{ on }">
                            <span v-on="on">
                              {{ putEllipsis(item.description, 60) }}
                            </span>
                          </template>
                          <span>{{ item.description }}</span>
                        </v-tooltip>
                      </td>
                      <td class="nowrap-row">
                        <v-tooltip v-if="item.units.length > 0" right>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" style="cursor: auto" v-on="on">
                              {{ getUnits(item) }}
                            </span>
                          </template>
                          <span v-for="(unit, index) in item.units" :key="index" style="display: block">
                            {{ unit.name }}
                          </span>
                        </v-tooltip>
                        <span v-else> - </span>
                      </td>
                      <td>{{ item.products_count }}</td>
                      <td>{{ item.segments.length ? 'SIM' : '-' }}</td>
                      <td>{{ item.activatable ? 'Ativável' : 'Livre' }}</td>
                      <td>
                        <v-tooltip top max-width="300px">
                          <template #activator="{ on }">
                            <span v-on="on">{{ getOfferTypes(item.types).length === 1 ? getOfferTypes(item.types)[0] : 'Múltiplas' }}</span>
                          </template>
                          <span>{{ getOfferTypesTooltip(item.types) }}</span>
                        </v-tooltip>
                      </td>
                      <td v-if="showTooltip(item.status)">
                        <v-tooltip top>
                          <template #activator="{ on }">
                            <span v-on="on">{{ getPeriod(item.start_date, item.end_date) }}</span>
                          </template>
                          <span>{{ getCampaignDuration(item) }}</span>
                        </v-tooltip>
                      </td>
                      <td v-else>
                        <span>
                          {{ getPeriod(item.start_date, item.end_date) }}
                        </span>
                      </td>
                    </tr>
                  </template>
                </paginated-data-table>
              </div>
            </template>
          </v-card>
        </v-col>
      </v-row>
      <action-buttons :save="save" :object="commercial" mode="banner" :franchise="franchise" />
    </v-container>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ActionButtons from '../components/ActionButtons.vue'
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { notOnlySpace, isUrlPrefix, isFuture } from '@/helpers/validators.js'
import { getStatusLabel, getUnits, getPeriod, putEllipsis } from '@/config/helpers.js'
import { deepDelete } from '@/helpers/deepDelete'
import { getProductFormatTypeLabel } from '@/modules/mobile/ofertas/helpers/productType.js'
import { QUERY_LIST_SALES_CAMPAIGNS, QUERY_SALES_CAMPAIGN_BY_ID } from '@/modules/campanhas/gestao-ofertas-v2/graphql'
import { MUTATION_UPSERT_DRAFT_BANNER, MUTATION_UPSERT_BANNER, QUERY_GET_APP_LINKS } from '../../graphql'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { QUERY_FLYERS } from '../../../encartes/graphql'
import Swal from 'sweetalert2'
import cloneDeep from 'lodash/cloneDeep'
import { DateTime } from 'luxon'

export default {
  components: {
    BasePageLayout,
    ActionButtons,
    PaginatedDataTable,
    TitleDescription: () => import('@/modules/campanhas/views/components/edit/TitleDescription.vue'),
    UnitsConfiguration: () => import('../components/UnitsConfiguration.vue'),
  },
  props: {
    commercial: Object,
    franchise: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: true,
    },
    offerSchedule: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    credits: 0,
    loadingEstimatedCost: false,
    offerScheduleLoading: false,
    estimatedCost: 0,
    savingDraft: false,
    unitError: false,
    externalLocal: '',
    internalLocal: '',
    linkRedirectLocal: 0,
    externalError: false,
    internalError: false,
    imageUploaded: false,
    errorDateFuture: null,
    flyersOptions: [],
    selectedFlyer: {},
    disableDatePicker: false,
    campaignSelected: {},
    markedCampaign: {},
    disableToggleOffer: false,
    disableSelectFlyer: false,
    sendAction: 'OTHER',
    showTooltipTitle: {},
    showTooltipDescription: {},
  }),
  computed: {
    isEnableExpandedBanner() {
      return this.$getAllowedModules()['enable_expanded_banner']
    },
    bannerSize() {
      return {
        width: this.isEnableExpandedBanner ? 800 : 720,
        height: this.isEnableExpandedBanner ? 500 : 300,
      }
    },
    ratioForExpandedBanner() {
      return this.isEnableExpandedBanner ? 8 / 5 : 0
    },
    boxOffersPlaceholderClasses() {
      const classes = ['box-banner']
      if (!this.hasBanner) classes.push(['empty-banner'])
      if (this.hasBanner && this.isEnableExpandedBanner) classes.push(['box-banner-expanded'])
      return classes
    },
    query() {
      return QUERY_LIST_SALES_CAMPAIGNS
    },
    queryVariables() {
      return {
        status: ['active', 'scheduled'],
        personalized: false,
        industry: false,
        includeAuto: this.linkRedirect === 4,
      }
    },
    queryName() {
      return 'offerSchedules'
    },
    useErpSalesAsOffersSchedules() {
      return this.$getAllowedModules()['use_erp_sales_as_offers_schedules']
    },
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'Sem link',
          value: 0,
          active: true,
        },
        {
          id: 1,
          label: 'Link externo',
          value: 1,
          active: true,
        },
        {
          id: 2,
          label: 'Link interno',
          value: 2,
          active: true,
        },
        {
          id: 3,
          label: 'Vincular oferta',
          value: 3,
          active: true,
        },
        ...(this.useErpSalesAsOffersSchedules
          ? [
              {
                id: 4,
                label: 'Vincular oferta do ERP',
                value: 4,
                active: true,
              },
            ]
          : []),
      ]
    },
    headers() {
      return [
        {
          text: '',
          value: '_id',
          width: '5%',
        },
        {
          text: 'Status',
          value: 'status',
          width: '7%',
        },
        {
          text: 'Nome',
          value: 'name',
          width: '15%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '18.5%',
        },
        {
          text: 'Lojas',
          value: 'units',
          width: '7.5%',
        },
        {
          text: 'Produtos',
          value: 'products_count',
          width: '9%',
        },
        {
          text: 'Personalizável',
          value: 'is_personalized',
          width: '1%',
          sortable: false,
        },
        {
          text: 'Modelo',
          value: 'activatable',
          width: '7%',
        },
        {
          text: 'Formato',
          value: 'types',
          width: '10%',
        },
        {
          text: 'Validade',
          value: 'start_date',
          width: '20%',
        },
      ]
    },
    isNewAndFranchise() {
      return !this.isNew && this.franchise
    },
    todayDate() {
      return DateTime.now().toFormat('yyyy-MM-dd')
    },
    initialDate() {
      return this.commercial.initial_date
    },
    finalDate() {
      return this.commercial.final_date
    },
    isActive() {
      return Boolean(this.commercial.status === 'ACTIVE' || this.commercial.status === 'FINISHED')
    },
    isFinished() {
      return Boolean(this.commercial.status === 'FINISHED')
    },
    minDate() {
      if (DateTime.now().toFormat('HH') < DateTime.fromObject({ hour: 20 }).toFormat('HH')) {
        return DateTime.now().toFormat('yyyy-MM-dd')
      }
      return DateTime.now().plus({ days: 1 }).toFormat('yyyy-MM-dd')
    },
    errorSendDate() {
      if (!this.$v.commercial || !this.$v.commercial.initial_date) return ''
      if (this.$v.commercial.initial_date.$error) {
        if (!this.$v.commercial.initial_date.required) return 'Selecione uma data de envio.'
        else if (!this.$v.commercial.initial_date.isFuture) return 'A data de envio deve ser no futuro.'
      }
      return ''
    },
    errorFinalDate() {
      if (!this.$v.commercial || !this.$v.commercial.final_date) return ''
      if (this.$v.commercial.final_date.$error) {
        if (!this.$v.commercial.final_date.required) return 'Selecione uma data de envio.'
        else if (!this.$v.commercial.final_date.isFuture) return 'A data de envio deve ser no futuro.'
      }
      return ''
    },
    labelBtnImg() {
      return this.hasBanner ? 'Alterar' : 'Selecionar'
    },
    hasBanner() {
      return Boolean(this.commercial.image_url !== '')
    },
    units() {
      return this.$store.getters.units
    },
    linkRedirect: {
      get() {
        return this.linkRedirectLocal
      },
      set(value) {
        this.linkRedirectLocal = value
        this.restoreDatePicker()
      },
    },
    external: {
      get() {
        return this.externalLocal
      },
      set(value) {
        this.externalLocal = value
      },
    },
    internal: {
      get() {
        return this.internalLocal
      },
      set(value) {
        this.internalLocal = value
      },
    },
    getLink: {
      get() {
        switch (this.linkRedirect) {
          default:
          case 0:
            return {
              type: 'NONE',
              link: '',
            }
          case 1:
            return {
              type: 'EXTERNAL',
              link: this.external,
            }
          case 2:
            return {
              type: 'INTERNAL',
              link: this.internal,
            }
        }
      },
      set({ type, link }) {},
    },
    alteracaoTitle() {
      if (this.newBanner) return 'Novo Banner'
      else return 'Editar Banner'
    },
    newBanner() {
      let path = this.$router.currentRoute.fullPath
      return path.includes('novo') && true
    },
    errorTitle() {
      if (!this.$v.commercial.title) return ''
      if (this.$v.commercial.title.$error) {
        if (!this.$v.commercial.title.required) return 'Dê um nome para esta campanha.'
        else if (!this.$v.commercial.title.minLength) return 'O título possui menos de 2 caracteres.'
        else if (!this.$v.commercial.title.maxLength) return 'O título excedeu 70 caracteres.'
        else if (!this.$v.commercial.title.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorDescription() {
      if (!this.$v.commercial.description) return ''
      if (this.$v.commercial.description.$error) {
        if (!this.$v.commercial.description.required) return 'Informe detalhes para melhor identificação da campanha.'
        else if (!this.$v.commercial.description.minLength) return 'A descrição possui menos de 2 caracteres.'
        else if (!this.$v.commercial.description.maxLength) return 'A descrição excedeu 150 caracteres.'
        else if (!this.$v.commercial.description.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    links() {
      return this.appPagesLinks
    },
  },
  apollo: {
    appPagesLinks: {
      query: QUERY_GET_APP_LINKS,
    },
    flyers: {
      query: QUERY_FLYERS,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      variables() {
        const variables = {
          status: ['ACTIVE', 'SCHEDULED'],
        }
        return variables
      },
      update(data) {
        this.flyersOptions = [
          ...data.flyers.flyers.map((flyer) => ({
            title: flyer.title,
            id: flyer._id,
            initialDate: flyer.initial_date,
            finalDate: flyer.final_date,
          })),
        ]
      },
    },
  },
  watch: {
    'commercial.action': async function (newvalue) {
      await this.onSelectViewSales()
    },
    'commercial.initial_date': function () {
      this.validateInitialDate()
    },
    units(units) {
      if (this.newBanner && this.commercial.units.length === 0) {
        this.commercial.units = units.filter((unit) => unit.active !== false).map((unit) => unit.id_erp)
      }
    },
    initialDate(value) {
      if (DateTime.fromISO(value) > DateTime.fromISO(this.commercial.final_date)) this.errorDateFuture = 'A data de envio deve ser no futuro.'
      else this.errorDateFuture = ''
    },
    finalDate(value) {
      if (DateTime.fromISO(this.commercial.initial_date) > DateTime.fromISO(value)) this.errorDateFuture = 'A data de envio deve ser no futuro.'
      else this.errorDateFuture = ''
    },
    linkRedirect(value) {
      if (value === 1) this.validateUrlPrefix()
      if (value === 2) {
        this.externalError = false
      }
    },
  },
  created() {
    this.$store.dispatch('getStates', ['fetchUnits'])
  },
  async mounted() {
    switch (this.commercial.type) {
      case 'NONE':
        this.internalLocal = 0
        break
      case 'EXTERNAL':
        this.externalLocal = this.commercial.link
        this.linkRedirectLocal = 1
        break
      case 'INTERNAL':
        this.internalLocal = this.commercial.link
        this.linkRedirectLocal = 2
        break
    }
    if (this.commercial.action) {
      switch (this.commercial.action.type) {
        case 'VIEW_SALES':
          await this.onSelectViewSales()
          break
        case 'VIEW_FLYER':
          this.selectedFlyer.id = this.commercial.action.reference_id
          if (this.isActive) {
            this.disableSelectFlyer = true
            this.disableDatePicker = true
          }
          break
      }
    }
    if (this.commercial.type === 'INTERNAL') this.internalLocal = this.commercial.link
    if (!this.newBanner) this.commercial.units = this.commercial.units.map((unit) => unit.id_erp)
    if (this.newBanner) this.commercial.units = this.units.filter((unit) => unit.active !== false).map((unit) => unit.id_erp)
  },
  methods: {
    putEllipsis,
    getStatusLabel,
    getPeriod,
    getUnits,
    async onSelectViewSales() {
      this.markedCampaign = this.commercial.action.reference_id
      await this.getOfferSchedule(this.commercial.action.reference_id)
      if (this.useErpSalesAsOffersSchedules && this.campaignSelected.origin === 'erp') {
        this.linkRedirectLocal = 4
      } else {
        this.linkRedirectLocal = 3
      }
      if (this.isActive) {
        this.disableDatePicker = true
        this.disableToggleOffer = true
      }
    },
    async getOfferSchedule(offerScheduleId) {
      try {
        this.offerScheduleLoading = true
        const { data } = await this.$apollo.query({
          query: QUERY_SALES_CAMPAIGN_BY_ID,
          variables: {
            id: offerScheduleId,
          },
          context: {
            uri: this.$microservicesUrls['sales'],
          },
          fetchPolicy: 'no-cache',
        })
        this.campaignSelected = data.offerSchedule
        this.handleValidateSendAction('OFFER')
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados de oferta', snackbarColor: 'error' })
      } finally {
        this.offerScheduleLoading = false
      }
    },
    getCampaignDuration(item) {
      if (item.status === 'active') {
        const { days: endCampaign } = DateTime.fromISO(item.end_date).diffNow(['days']).toObject()
        return `A oferta terminará em ${parseInt(endCampaign)} dia(s)`
      } else if (item.status === 'scheduled') {
        const { days: initCampaign } = DateTime.fromISO(item.start_date).diffNow(['days']).toObject()
        return `A oferta iniciará em ${parseInt(initCampaign)} dia(s)`
      }
    },
    getOfferTypesTooltip(types) {
      return this.getOfferTypes(types).join(', ')
    },
    getOfferTypes(types) {
      const offerTypes = []
      types.forEach((type) => offerTypes.push(getProductFormatTypeLabel(type)))
      return offerTypes
    },
    showTooltip(status) {
      return status === 'active' || status === 'scheduled'
    },
    extrasValidates() {
      if (this.linkRedirectLocal === 3 && typeof this.markedCampaign !== 'string') {
        this.$snackbar({ message: 'Selecione uma Oferta', snackbarColor: 'error' })
        return 'DENIED'
      }
    },
    validateInitialDate() {
      const today = new Date()
      const initialDate = new Date(this.commercial.initial_date)
      if (initialDate < today) {
        this.commercial.initial_date = today.toISOString().split('T')[0]
      }
    },
    handleValidateSendAction(type) {
      switch (type) {
        case 'OFFER':
          this.sendAction = 'OFFER'
          break
        case 'FLYER':
          this.sendAction = 'FLYER'
          break
        case 'OTHER':
          this.sendAction = 'OTHER'
          break
      }
    },
    getActionData(banner) {
      switch (this.sendAction) {
        case 'OFFER':
          return {
            reference_id: this.campaignSelected._id,
            link: 'SalesScreen',
            type: 'INTERNAL',
          }
        case 'FLYER':
          return {
            reference_id: this.selectedFlyer.id,
            link: banner.link,
            type: banner.type,
          }
        case 'OTHER':
          if (this.linkRedirectLocal === 0) {
            return null
          } else {
            return {
              reference_id: null,
              link: banner.link,
              type: banner.type,
            }
          }
      }
    },
    restoreDatePicker() {
      this.commercial.initial_date = undefined
      this.commercial.final_date = undefined
      this.disableDatePicker = false
      this.selectedFlyer = {}
      this.markedCampaign = {}
      this.handleValidateSendAction('OTHER')
    },
    toggleOfferSelected(campaignSelected) {
      if (this.disableToggleOffer) return
      this.markedCampaign = campaignSelected._id
      this.campaignSelected = campaignSelected
      this.commercial.initial_date = campaignSelected.start_date
      this.commercial.final_date = campaignSelected.end_date
      this.disableDatePicker = true
      this.handleValidateSendAction('OFFER')
    },
    getStatusClass(status) {
      switch (status) {
        case 'active':
          return 'status-active'
        case 'scheduled':
          return 'status-scheduled'
        default:
          return ''
      }
    },
    onFlyerSelect(selectedItem) {
      this.commercial.initial_date = DateTime.fromISO(selectedItem.initialDate).toFormat('yyyy-MM-dd')
      this.commercial.final_date = DateTime.fromISO(selectedItem.finalDate).toFormat('yyyy-MM-dd')
      this.disableDatePicker = true
      this.handleValidateSendAction('FLYER')
    },
    getImageNameFormated(url) {
      let splitName = url.split('/').pop().split('-')
      if (url.split('/').length === 1) return url
      return splitName.slice(5, splitName.length).join('-')
    },
    validateUrlPrefix() {
      this.externalError = this.getSafe(() => this.external === '') || !isUrlPrefix(this.external)
    },
    validateUrlInternal() {
      this.restoreDatePicker()
      this.internalError = this.getSafe(() => this.internal === '')
    },
    deleteFile() {
      this.commercial.image_url = ''
    },
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    async modifyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.imageUploaded = true
          this.commercial.image_url = url
        })
    },
    async save(isDraft) {
      if (this.extrasValidates() === 'DENIED') return
      this.savingDraft = isDraft
      if (this.savingDraft) this.externalError = false

      this.$v.$reset()
      this.$v.$touch()

      if (this.$v.$error && !this.isActive && !this.$v.commercial.initial_date.$error) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        this.$nextTick(() => {
          this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
        })
        return
      }

      if ((this.externalError && this.linkRedirectLocal === 1) || (this.internalError && this.linkRedirectLocal === 2)) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        this.$nextTick(() => {
          this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
        })
        return
      }

      if (!this.savingDraft) {
        const now = DateTime.now().startOf('day')
        const initialDate = DateTime.fromISO(this.commercial.initial_date).startOf('day')
        const finalDate = DateTime.fromISO(this.commercial.final_date).startOf('day')

        if (initialDate < now) {
          this.$snackbar({ message: 'A data de início deve ser igual ou maior que hoje.', snackbarColor: 'error' })
          return
        }

        if (finalDate < now) {
          this.$snackbar({ message: 'A data de fim deve ser igual ou maior que hoje.', snackbarColor: 'error' })
          return
        }

        if (finalDate < initialDate) {
          this.$snackbar({ message: 'A data de fim deve ser igual ou maior que a data de início.', snackbarColor: 'error' })
          return
        }
      }

      const banner = cloneDeep(this.commercial)
      deepDelete(banner, ['__typename', 'status', 'metrics'])
      if (banner.action) {
        deepDelete(banner.action, ['__typename'])
      }
      banner.type = this.getLink.type
      banner.link = this.getLink.link
      const mutation = isDraft ? MUTATION_UPSERT_DRAFT_BANNER : MUTATION_UPSERT_BANNER

      this.$apollo
        .mutate({
          mutation: mutation,
          variables: {
            data: {
              ...banner,
              action: this.getActionData(banner),
            },
          },
        })
        .then(() => {
          Swal.fire({
            text: 'Seu banner foi salvo',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
          this.$router.push('/mobile/banners').catch(() => {})
        })
        .catch((error) => {
          console.error(error)
          if (error.graphQLErrors && error.graphQLErrors.some((e) => e.message === 'offersScheduleId is already linked to another banner')) {
            this.$snackbar({ message: 'Oferta já vinculada a outro banner', snackbarColor: 'error' })
          } else {
            this.$snackbar({ message: 'Ocorreu um erro ao salvar o banner', snackbarColor: 'error' })
          }
        })
    },
  },
  validations() {
    if (this.savingDraft) {
      return {
        commercial: {
          title: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(70),
            notOnlySpace,
          },
          description: {
            notOnlySpace,
          },
          initial_date: {},
          final_date: {},
          image_url: {},
          units: {},
        },
      }
    }
    return {
      commercial: {
        title: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(70),
          notOnlySpace,
        },
        description: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(150),
          notOnlySpace,
        },
        initial_date: {
          required,
          isFuture,
        },
        final_date: {
          required,
          isFuture,
        },
        image_url: {
          required,
        },
        units: {
          required,
        },
      },
    }
  },
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;
.alteracao-banners {
  min-width: 1020px;
  h4 {
    font-size: 20px;
    font-weight: normal;
  }
  h5 {
    font-size: 16px;
    font-weight: normal;
  }
  .hint-text {
    font-size: 14px;
    line-height: 21px;
    &.external {
      max-width: 700px;
    }
    b {
      color: $marca-1;
      font-weight: 700;
    }
  }
  .message-box {
    border: 1px solid $cinza-l80;
    border-radius: 5px;
  }
  .error-text {
    color: $vermelho-0 !important;

    font-size: 12px !important;
    padding-left: 0 !important;

    margin: 0;
  }
  .v-dialog__container {
    display: inline-block !important;
  }
  .outer-frame-push {
    border: 2px solid $cinza-l80;
    border-radius: 40px 40px 0 0;
    border-bottom: 0;
    width: 430px;
    @media screen and (max-width: $tablet-size) {
      margin: 20px 30px 0;
      padding: 20px 10px 0;
    }
    @media screen and (min-width: $tablet-size) {
      margin: 20px 30px 0;
      padding: 20px 10px 0;
    }
    .camera-slot {
      border: 2px solid $cinza-l80;
      border-radius: 20px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 20px;
      width: 20px;
      margin-right: 0.8vw;
    }
    .ear-speaker-slot {
      border: 2px solid $cinza-l80;
      border-radius: 30px;
      display: inline-block;
      margin-bottom: 50px;
      height: 20px;
      width: 100px;
      margin-left: 8px;
    }
    .inner-frame-mobile {
      border: 2px solid $cinza-l80;
      border-bottom: 0;
      height: 100%;
      overflow: hidden;
      .navbar {
        display: flex;
        flex-direction: row-reverse;
        background-color: $cinza-l90;
        padding: 15px;
        .navbar-padding {
          display: inline-block;
        }
      }
      .box-offers-placeholder {
        border-radius: 0 0 10px 10px;
        border: 1.5px solid $cinza-l80;
        height: 10px;
        margin: 0 15px 0 15px;
        border-top: 0;
      }
      .box-banner {
        height: 140px;
        margin: 20px;
        justify-content: center;
        align-items: center;
        display: flex;
      }
      .box-banner-expanded {
        margin: 60px 20px;
      }
      .empty-banner {
        border: 1.5px solid $cinza-l80;
      }
      .box-buttons-group {
        flex-direction: row;
        display: flex;
        .box-button-placeholder {
          border-radius: 10px 10px 0 0;
          border: 1.5px solid $cinza-l80;
          border-bottom: 0;
          height: 300px;
          width: 300px;
          margin: 0 20px;
        }
        .first-button {
          margin-right: 0;
        }
      }
    }
  }
}
.status-indicator {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;

  &.status-active {
    background-color: #0da740;
  }

  &.status-scheduled {
    background-color: #faca00;
  }
}
.status-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

::v-deep .v-data-table-header {
  background-color: $cinza-l90;

  th.text-start {
    white-space: pre;
  }
}

::v-deep tbody > tr {
  line-height: 50px;
  overflow: hidden;
  height: 50px;

  td {
    line-height: 50px;
    overflow: hidden;
    height: 50px;
  }
}

.is-disabled {
  color: grey;
  opacity: 0.5;
}
</style>
